import { useMemo } from 'react'

export const useIsMac = (): boolean => {
  return useMemo(() => navigator.userAgent.includes('Mac'), [])
}
